import { useTranslation } from "react-i18next";
import { TextInput } from "@carbon/react";
import ConfirmDialog from "../../components/carbon/ConfirmDialog/ConfirmDialog";
import "./bid.scss";

export interface CancelOrderDialogProps {
  open: boolean;
  cancelMessage: string;
  onChangeCancelMessage: (value: string) => void;
  onConfirm: () => void;
  onClose: () => void;
  isPending: boolean;
  /** A distinct input `id` per mount — `BuyerBid.tsx` and `JointBuyerBid.tsx` both render this,
   * and Carbon's `TextInput` needs a unique DOM id either way. */
  inputId: string;
}

/**
 * The "cancel this RFQ" confirmation (Task 7) — identical `ConfirmDialog` + required-comment
 * `TextInput` shape in both `BuyerBid.tsx` (single order) and `JointBuyerBid.tsx` (joint order,
 * cancels every line at once); only what `onConfirm` actually does differs, so that stays owned
 * by each caller. Mirrors `PurchaseRequestV2Detail.tsx`'s own reject dialog — a `ConfirmDialog`
 * whose `body` carries a required text field, gated via `confirmDisabled`.
 */
const CancelOrderDialog = ({
  open,
  cancelMessage,
  onChangeCancelMessage,
  onConfirm,
  onClose,
  isPending,
  inputId,
}: CancelOrderDialogProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      open={open}
      danger
      title={t("tenders.data.cancel")}
      body={
        <div className="bid-cancel-form">
          <p>{t("tenders.data.cancelQuestion")}</p>
          <TextInput
            id={inputId}
            labelText={`${t("tenders.data.cancelBrief")} *`}
            value={cancelMessage}
            onChange={(event) => onChangeCancelMessage(event.target.value)}
          />
        </div>
      }
      confirmLabel={t("tenders.data.cancel")}
      onConfirm={onConfirm}
      onCancel={onClose}
      isPending={isPending}
      confirmDisabled={!cancelMessage}
    />
  );
};

export default CancelOrderDialog;
